import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Layout from "../Components/Layout/Layout";
import * as Yup from "yup";
import {
  Formik,
  Field,
  ErrorMessage,
  Form as FormikForm,
  FieldArray,
} from "formik";
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addAdmin, addChatBot, editAdmin, getAdmin, getChatBot, updateFile } from "../Redux/Actions/event";
import { toast } from "react-toastify";
import { startstopLoading } from "../Redux/Reducers/globalSlice";

const validationSchema = Yup.object({
  email: Yup.string().email("Invalid email format").required("Required"),
  firstName: Yup.string().required("Required"),
  chatbotPermissions: Yup.array(),
  faqPermissions: Yup.array(),
  promptPermissions: Yup.array(),
  feedbackPermissions: Yup.array(),
}).test(
  "at-least-one-permission",
  "At least one permission must be selected",
  function (values) {
    const { chatbotPermissions, faqPermissions, promptPermissions, feedbackPermissions } = values;

    if (
      (!chatbotPermissions || chatbotPermissions.length === 0) &&
      (!faqPermissions || faqPermissions.length === 0) &&
      (!promptPermissions || promptPermissions.length === 0) &&
      (!feedbackPermissions || feedbackPermissions.length === 0)
    ) {
      return this.createError({
        path: "chatbotPermissions",
        message: "At least one permission must be selected",
      });
    }

    return true;
  }
);

export default function AddNewUser() {
  const currentAdmin = useSelector((e) => e.botAuth.adminDetails);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const [loading, setLoading] = useState(false);

  const initialValues = {
    email: id ? currentAdmin?.email : "",
    firstName: id ? currentAdmin?.firstName : "",
    chatbotPermissions: id ? currentAdmin?.chatbotPermissions : [],
    faqPermissions: id ? currentAdmin?.faqPermissions : [],
    promptPermissions: id ? currentAdmin?.promptPermissions : [],
    feedbackPermissions: id ? currentAdmin?.feedbackPermissions : [],
  };

  const RoleCheckbox = ({ name, label, value, setFieldValue, values }) => {
    const handleChange = (event) => {
      const isChecked = event.target.checked;
      const updatedValues = isChecked
        ? [...values[name], value]
        : values[name].filter((v) => v !== value);
      setFieldValue(name, updatedValues);
    };
    return (
      <li>
        <input
          type="checkbox"
          checked={values[name]?.includes(value)}
          onChange={handleChange}
        />
        <label>{label}</label>
      </li>
    );
  };

  const PermissionGroup = ({ title, name, values, setFieldValue }) => (
    <div className="chatbots-add-new">
      <p>{title}</p>
      <ul>
        <RoleCheckbox name={name} label="Edit" value={0} setFieldValue={setFieldValue} values={values} />
        <RoleCheckbox name={name} label="Delete" value={1} setFieldValue={setFieldValue} values={values} />
        <RoleCheckbox name={name} label="Add" value={2} setFieldValue={setFieldValue} values={values} />
      </ul>
    </div>
  );

  const handleSubmit = async (values) => {
    if (id) {
      values['adminId'] = id
    }
    let action = id ? editAdmin : addAdmin
    try {
      await dispatch(action(values)).then((res) => {
        if (res.payload.status == 201 || res.payload.status === 200) {
          // toast.success(res?.payload?.message);
          navigate("/admin");
        } else {
          // setLoading(false);
        }
      });
    } catch (error) {
      // setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(startstopLoading(true));
      dispatch(getAdmin({ id })).then(() => {
        dispatch(startstopLoading(false));
      });
    }
  }, [dispatch]);

  return (
    <Layout>
      <Container fluid>
        <div className="filters pb-2">
          <div className="inner-filter-field">
            <div className="image-heading-text">
              <h2>{id ? "Edit" : "Add"} New user</h2>
            </div>
          </div>
          <div className=" new-tabs-add">
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize={true}>
              {({ values, setFieldValue, handleSubmit, errors, touched, }) => (
                <FormikForm onSubmit={handleSubmit}>
                  <div className="create-notification-page new-tabs-add">
                    <div className="general-heading">
                      <h2>General</h2>
                    </div>
                    <div className="category-field">
                      <div className="general-box">
                        <Row>
                          <Col lg={6}>
                            <div className="modal-input">
                              <label>Name</label>
                              <Form.Group>
                                <Field name="firstName" type="text" className="form-control" placeholder="Enter your name" />
                                <ErrorMessage name="firstName" component="div" className="text-danger" />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="modal-input">
                              <label>Email</label>
                              <Form.Group>
                                <Field name="email" type="text" className="form-control" placeholder="Enter your email" />
                                <ErrorMessage name="email" component="div" className="text-danger" />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="modal-input mt-3">
                              <label>Role</label>
                              <PermissionGroup title="Chatbots" name="chatbotPermissions" values={values} setFieldValue={setFieldValue} />
                              <PermissionGroup title="Feedback" name="feedbackPermissions" values={values} setFieldValue={setFieldValue} />
                              <PermissionGroup title="Prompt" name="promptPermissions" values={values} setFieldValue={setFieldValue} />
                              <PermissionGroup title="FAQ" name="faqPermissions" values={values} setFieldValue={setFieldValue} />
                            </div>
                          </Col>
                          <ErrorMessage name="chatbotPermissions" component="div" className="text-danger" />
                        </Row>
                      </div>
                      <div className="create-btn">
                        <button type="submit">Save</button>
                      </div>
                    </div>
                  </div>
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
        <div className="made-with">
          <div className="pixinvent">
            <p>
              © {new Date().getFullYear()}, Made with ❤️ by{" "}
              <span>Codobux</span>
            </p>
          </div>
        </div>
      </Container>
    </Layout>
  );
}
